<template>
  <div>
    <h4>Dettaglio settimana corrente:</h4>

    <Spinner v-if="loading"/>

    <template >
      <b-row align-v="center">
        <!-- <b-col cols="6" v-if="chartOptions">
          <apexchart height="400" :options="chartOptions" :series="series"/>
        </b-col> -->
        <b-col cols="6">
          <div style="height:400px;" :id="chartId"></div>
        </b-col>
        <b-col cols="6">

          <table class="table striped table-hover">
            <thead>
              <tr>
                <th></th>
                <th class="table-value-column">Settimana {{ tableFirstColumnHeader }}</th>
                <th class="table-value-column">{{ tableSecondColumnHeader }}</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in tableRows"
                  :key="row.date"
                  :class="{'table-last-row': index + 1 === tableRows.length }">
                <td class="table-date-column">{{ row.date }}</td>
                <td class="table-value-column">
                  <span v-if="row.currentYearSum">
                    {{ row.currentYearSum | formatDecimal(2) }}
                  </span>
                </td>
                <td class="table-value-column">
                  <span v-if="row.previousYearSum">
                    {{ row.previousYearSum | formatDecimal(2) }}
                  </span>
                </td>
                <td>
                  <Delta :value-delta="row.delta"/>
                </td>
              </tr>
            </tbody>
          </table>

        </b-col>
      </b-row>
    </template>
  </div>
</template>

<script>
import chartMixin from './chart';
import moment from 'moment';
import Delta from './../ux/Delta';
import Spinner from './../ux/Spinner';
import { ACTION_SLOTS } from '@/store/modules/dashboard/actions';
import { API_DATE_FORMAT } from '@/store/modules/dashboard/consts';
import {mapState} from "vuex";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4lang_it_IT from "@amcharts/amcharts4/lang/it_IT";


const FIRST_COLUMN_DATE_FORMAT = 'w - YYYY';
const SECOND_COLUMN_DATE_FORMAT = 'YYYY';
const ROW_DATE_FORMAT = 'dddd - DD/MM/YYYY';
const X_AXIS_DATE_FORMAT = 'DD MMM';

export default {
  name: "Slots",

  props: {
    date: {
      required: true,
    },

    vector: {
      required: true,
      type: String,
    },
  },

  components: {
    Delta,
    Spinner,
  },

  mixins: [chartMixin],

  data() {
    return {
      chartId: 'Slots_654',

      currentYearSeries: [],
      previousYearSeries: [],

      valueNames: ['F1', 'F2', 'F3'],
      series: [],
      chartOptions: null,

      loading: false,
      yAxis:{},
      chart: undefined
    };
  },

  watch: {
    stateSelectedSiteId() {
      this.loadData(true);
    },

    date(newValue, oldValue) {
      // This condition for widgets that doesn't depend on any 'date' as 'Weather'
      if (!newValue || !oldValue) {
        return;
      }

      if (!newValue.isSame(oldValue, this.dateComparisonType)) {
        this.loadData();
      }
    },
  },

  computed: {
    ...mapState({
      stateSelectedSiteId: state => state.selectedSiteId,
    }),

    tableFirstColumnHeader() {
      if (!this.currentYearSeries.length) {
        return '';
      }

      const firstRangeDate = this.currentYearSeries[0][0];
      return moment(firstRangeDate).format(FIRST_COLUMN_DATE_FORMAT);
    },

    tableSecondColumnHeader() {
      if (!this.previousYearSeries.length) {
        return '';
      }

      const firstRangeDate = this.previousYearSeries[0][0];
      return `Baseline ${moment(firstRangeDate).format(SECOND_COLUMN_DATE_FORMAT)}`;
    },

    tableRows() {
      const rows = this.currentYearSeries.map((currentYearRow, rowIndex) => {
        const date = moment(currentYearRow[0]).format(ROW_DATE_FORMAT);
        const currentYearSum = currentYearRow.slice(1).reduce((sum, value) => sum + value, 0);

        const previousYearRow = this.previousYearSeries[rowIndex];
        const previousYearSum = previousYearRow.slice(1).reduce((sum, value) => sum + value, 0);

        let delta = null;
        if (currentYearSum && previousYearSum) {
          delta = (currentYearSum - previousYearSum) / previousYearSum;
        }

        return {
          date,
          currentYearSum: currentYearSum ? +currentYearSum : '',
          previousYearSum: previousYearSum ? +previousYearSum : '',
          delta,
        };
      });

      const currentYearTotal = rows.reduce((sum, row) => row.currentYearSum
                                                         ? sum + row.currentYearSum : sum, 0);
      const previousYearTotal = rows.reduce((sum, row) => row.previousYearSum
                                                          ? sum + row.previousYearSum : sum
        , 0);

      let delta = null;
      if (currentYearTotal && previousYearTotal) {
        delta = (currentYearTotal - previousYearTotal) / previousYearTotal;
      }

      rows.push({
        date: 'TOTALE SETTIMANA',
        currentYearSum: currentYearTotal ? currentYearTotal : '',
        previousYearSum: previousYearTotal ? previousYearTotal : '',
        delta,
      });

      return rows;
    },
  },

  mounted() {
    // this.setChartOptions();
    moment.locale("it");
    this.loadData();
  },

  beforeDestroy() {
    this.unload();
  },

  methods: {
    async loadData(force = false) {
      if (this.loading && !force) {
        return;
      }

      this.$emit('loading-started');

      try {
        this.loading = true;

        const data = await this.$store.dispatch(
          `dashboard/${ACTION_SLOTS}`,
          {
            date: this.date,
          },
        );

        const date = data[0].values[0][0];

        if (date !== this.date.format(API_DATE_FORMAT)) {
          this.$emit('set-date-from-response', date);
        }

        this.currentYearSeries = data[0].values.slice(0, 7);
        this.previousYearSeries = data[1].values.slice(0, 7);
      } finally {
        this.$emit('loading-finished');

        this.loading = false;
      }

      this.setupChart();
    },

    setupChart() {
      const values = this.currentYearSeries;
      // this.series = this.valueNames.map((name, index) => {
      //   const valueIndex = index + 1;
      //   return {
      //     name,
      //     data: values.map((value) => value[valueIndex] ? value[valueIndex] : null),
      //   };
      // });

      // this.chartOptions.xaxis.categories = values.map(([date]) => (date));

      // setup amcharts here
      let chartData = {
        mus:['Data'],
        columns:['Data'],
        sources:[],
        values: values
      }
      for(let i=1; i < values[0].length; i++ ){
        chartData.sources.push('Source'+i);
        chartData.columns.push('columns'+i)
      }
      this.makeChart( this.chartId,_.cloneDeep(chartData));
    },

    makeChart( chartId, data) {
      this.colors = this.$store.state.colors;
      let chart = am4core.create(chartId, am4charts.XYChart);
      chart.language.locale = am4lang_it_IT;
      chart.language.locale["_decimalSeparator"] = ",";
      chart.language.locale["_thousandSeparator"] = "'";
      chart.colors.list = this.colors.map( e => {
        return  am4core.color(e)
      })

      let dateAxis = chart.xAxes.push(new am4charts.DateAxis());
      dateAxis.cursorTooltipEnabled = false;
      dateAxis.renderer.grid.template.disabled = true;
      dateAxis.dateFormats.setKey("day", "dd MMM");
      dateAxis.renderer.minGridDistance = 10;


      chart.scrollbarX = new am4core.Scrollbar();
      chart.scrollbarX.parent = chart.bottomAxesContainer;
      chart.cursor = new am4charts.XYCursor();
      chart.cursor.xAxis = dateAxis;
      // chart.numberFormatter.numberFormat = "#.";
      chart.legend = new am4charts.Legend();
      chart.exporting.menu = new am4core.ExportMenu();
      chart.series.clear();
      this.yAxis = {};
      data.mus.forEach((mu, index) => {
        if(! this.yAxis[mu]) {
          let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
          valueAxis.min = 0;
          valueAxis.name = data.columns[index + 1];
          valueAxis.title.text = ``;
          valueAxis.title.fontWeight = 600;
          // valueAxis.fill = am4core.color(this.colors[index % this.colors.length]);
          valueAxis.cursorTooltipEnabled = false;
          this.yAxis[mu] = valueAxis;
        }
      });
      this.createSeries(data,chart);
    },

    createSeries(data,chart){
      try{
      data.sources.forEach((source, index) => {
        let series = chart.series.push(new am4charts.ColumnSeries());

        let seriesColor = this.colors[  index % this.colors.length];
        // series.stroke = am4core.color(seriesColor);
        series.dataFields.valueY = source;
        series.stacked = true;
        series.tooltip.pointerOrientation = "vertical";
        series.name = 'F'+ (index+1);
        series.dataFields.dateX = "date";
        series.columns.template.width = am4core.percent(50);

        // series.tooltip.label.propertyFields.fill = am4core.color('#FFFFFF');

        series.connect = false;
        series.tooltip.getFillFromObject = false;
        series.tooltip.autoTextColor = false;
        series.adapter.add("tooltipText", (text, target) => {
          var sum=target.tooltipDataItem.dataContext;
          let tooltipData = target.tooltipDataItem.dataContext;
          var seriesData=[];
          seriesData.push(sum.value.toString().split('.'));
          var valueY = seriesData[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, "'");          
          let strokeColor = target.stroke.hex;
          let dateFormat = this.getTooltipFormat(tooltipData.isComparing);
          var text = `${dateFormat}  \n [${strokeColor}]● [/] ${tooltipData.name} [bold]${valueY}[/]`
          return text;
        });

        series.tooltip.label.fill = am4core.color("black");
        var series_data = [];

        data.values.forEach((item, valueIndex) => {
          var dataItem = {};
          dataItem.value =  item[index + 1] ?   item[index + 1].toFixed(2) : 0;
          dataItem.name = "F"+ (index+1)
          dataItem.date = new Date(item[0]);

          dataItem[source] = item[index + 1];
          series_data.push(dataItem);
        })
        series.data = series_data;
      });
      }
      catch(error){

      }
   },

    getTooltipFormat(){
      return'{dateX.formatDate("MMM dd - EEE")}' ;
    },

    setChartOptions() {
      this.chartOptions = {
        ...this.defaultChartOptions,

        colors: ['#74C69E', '#6995A7', '#C6746B'],
        stroke: {},
        chart: {
          ...this.defaultChartOptions.chart,

          type: 'bar',
          height: 250,
          stacked: true,
        },
        xaxis: {
          categories: [],
          labels: {
            formatter: (val) => {
              return moment(val).format(X_AXIS_DATE_FORMAT);
            },
          },
        },
        yaxis: {
          labels: {
            formatter: (val) => {
              return this.$options.filters.formatDecimal(val);
            },
          },
        },

        tooltip: {
          x: {
            formatter: (val, { dataPointIndex }) => {
              return moment(this.chartOptions.xaxis.categories[dataPointIndex]).format(X_AXIS_DATE_FORMAT);
            },
          },
          y: {
            formatter: (val) => {
              return this.$options.filters.formatDecimal(val, 2);
            },
          },
        },

        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '50%',
          },
        },
      };
    },

    disableAllExceptMondays(date) {
      return date.weekday() !== 0;
    },

    unload() {
      if(this.chart){
        this.chart.dispose();
        this.chart = undefined;
      }
    },
  },
}
</script>

<style scoped>
.table {
  font-size: 12px;
}

.table-date-column {
  text-transform: capitalize;
}

.table-value-column {
  text-transform: capitalize;
  text-align: center;
}

.table-last-row {
  font-size: 14px;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/VectorWidgets/widgets/Slots.vue